// extracted by mini-css-extract-plugin
module.exports = {"wrap_1000w":"wrap_1000w-2g6szn-5 clearfix","left_640w":"left_640w-2AvyDK6W","right_300w":"right_300w-2yNZ5gXm"};